<template>
  <div :class="$style[`content`]">
    <div :class="$style[`form-title`]">Submit your request</div>
    <div :class="$style[`form`]">
      <div :class="$style[`form-input`]">
        <div :class="$style[`input-box`]">
          <div v-if="!data.nameFocus" :class="[$style[`input-empty`], $style[`input`]]" @click="handleName(`name`)">Your name<span :class="$style[`star`]">*</span></div>
          <input ref="name" :class="[$style[`input`]]" name="name" v-model="data.name" required @focus="handleNameFocus" @blur="handleBlur(`name`)" />
        </div>
        <div :class="$style[`form-error`]" v-if="data.nameError">{{ data.nameError }}</div>
      </div>
      <div :class="$style[`form-input`]">
        <div :class="$style[`input-box`]">
          <div v-if="!data.emailFocus" :class="[$style[`input-empty`], $style[`input`]]" @click="handleName(`email`)">Your email<span :class="$style[`star`]">*</span></div>
          <input ref="email" :class="[$style[`input`]]" name="email" v-model="data.email" required @focus="handleNameFocus" @blur="handleBlur(`email`)" />
        </div>
        <div :class="$style[`form-error`]" v-if="data.emailError">{{ data.emailError }}</div>
      </div>
      <div :class="$style[`form-input`]">
        <div :class="$style[`input-box`]">
          <div v-if="!data.contentFocus" :class="[$style[`input-empty`], $style[`textarea`]]" @click="handleName(`content`)">Please fill in the proposal<span :class="$style[`star`]">*</span></div>
          <textarea ref="content"  :class="[$style[`textarea`]]" name="content" v-model="data.content" required @focus="handleNameFocus" @blur="handleBlur(`content`)" />
        </div>
        <div :class="$style[`form-error`]" v-if="data.contentError">{{ data.contentError }}</div>
      </div>
      <div :class="$style[`form-tips`]">
        In order to help you solve the problem faster, we hope you can describe the problem in as much detail as possible.For example, you can give examples of authorization issues, or copy the pop-up prompt that appears on the instruction page.Thank you for your cooperation.
      </div>
      <div :class="$style[`form-button`]">
        <dButton :class="[$style[`message`]]" :disable="disable" @click.stop="handleMessage">
          <span :class="$style.message_text">Send Message</span>
        </dButton>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {reactive, ref} from "vue";
import dButton from '@components/public/d-button/d-button.vue'
import EmailQuestion from "global-common/apis/p-clippng/email/user-question.ts";
import {checkEmail} from "global-common";
import {useStoreUserInfo} from "@stores/useStoreUserInfo.ts";
import CreateMessage from "@helpers/CreateMessage.ts";

const data = reactive({
  name: ``,
  email: ``,
  content: ``,
  nameFocus: false,
  emailFocus: false,
  contentFocus: false,
  nameError: ``,
  emailError: ``,
  contentError: ``,
})
const name = ref(null)
const email = ref(null)
const content = ref(null)
const disable = computed(() => !data.name || !data.email || !data.content)
const handleName = ( type: string ) => {
  rest();
  if(type === `name`) {
    name.value.focus();
  }else if(type === `email`) {
    email.value.focus();
  }else if (type === `content`) {
    content.value.focus();
  }
  data[`${type}Focus`] = true;
}
const rest = () => {
  data.nameFocus = !!data.name;
  data.emailFocus = !!data.email;
  data.contentFocus = !!data.content;
  name.value.blur();
  email.value.blur();
  content.value.blur();
}
const restError = () => {
  data.nameError =``
  data.emailError = ``
  data.contentError = ``
}
const handleBlur = ( type ) => {
  data[`${type}Focus`] = !!data[type];
}
const handleNameFocus = () => {

}
const handleMessage = async () => {
  if(disable.value) return;
  const isEmail = checkEmail ( data.email );
  if ( !isEmail ) {
    data.emailError = `Please enter the correct email address`;
    return;
  }

  try{
    const { getToken } = useStoreUserInfo();
    const [err, res] = await EmailQuestion({token: getToken(), title: data.name, content: data.content, email: data.email });
    if (err) throw err;
    restError();
    new CreateMessage({
      content: `success`,
      type: 'success',
      duration: 3000
    })
  } catch (e) {
    new CreateMessage({
      content: e.message,
      type: 'warn',
      duration: 3000
    })
  }
}
</script>
<style lang="scss" module src="./contact.scss"></style>
